import * as layout from '../../../components/markLayout.module.css';
import { MarkSelect, MarkLabel } from '../../../components/MarkControls';
import React, { useId } from 'react';
import type { DripStep } from '../../../types';
type Props = {
    label: string;
    value: string;
    onChange: (value: string) => void;
    steps: DripStep[];
    currentStepId: string;
    allowSelfLoop?: boolean;
    disabled?: boolean;
};
const RefPicker: React.FC<Props> = ({
    label,
    value,
    onChange,
    steps,
    currentStepId,
    allowSelfLoop = false,
    disabled
}) => {
    const selectId = useId();
    const options = steps.filter((s) => s.id !== currentStepId || allowSelfLoop);
    return (
        <div className={layout.field}>
            <MarkLabel htmlFor={selectId}>{label}</MarkLabel>
            <MarkSelect
                id={selectId}
                value={value}
                onChange={(e) => onChange(e.currentTarget.value)}
                disabled={disabled}
            >
                <option value="exit">exit</option>
                {options.map((s) => (
                    <option key={s.id} value={s.id}>
                        {s.id} ({s.type})
                    </option>
                ))}
            </MarkSelect>
        </div>
    );
};
export default RefPicker;
